import styled from "styled-components";

type ButtonGroupProps = {
  align?: "left" | "center" | "right";
  spaceBelow?: boolean;
};

const ButtonGroup = styled.div<ButtonGroupProps>`
  text-align: ${({ align }) => align};
  margin-bottom: ${({ spaceBelow }) => spaceBelow && "1rem"};

  > button {
    margin-left: 0.5rem;
    margin-right: 0.5rem;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }
`;

export default ButtonGroup;
